<template>
  <div class="ProjectEdit__part">
    <violet-bar>Nature du projet</violet-bar>
    <help-message>
      <h3 slot="title">Nature du projet</h3>
      <p>
        <strong>Typologies</strong>, et <strong>Programme</strong>, permettent
        d'entrer <strong>plusieurs valeurs</strong>.<br />
        C'est un fonctionnement que vous rencontrerez à bien d'autres endroits
        de l'application. <br />
        Pour ajouter une étiquette, tapez les premières lettres dans le champ de
        texte.<br />Si l'étiquette existe, elle vous sera proposée, et vous
        pourrez cliquer dessus. <br />
        Sinon, vous pouvez l'écrire en entier, puis appuyer sur le bouton "+".
        Elle sera disponible en suggestion par la suite. <br />Pour enlever une
        étiquette, vous pouvez cliquer sur la croix (<span
          class="delete is-small"
        ></span
        >) qui se trouve sur sa droite.
      </p>
    </help-message>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Typologies</label>
            <kv-suggestor-multiple
              :type="'typologies'"
              @update="project.typologies = $event"
              :items="project.typologies"
            ></kv-suggestor-multiple>
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Programme [entête]</label>
            <kv-suggestor-multiple
              :type="'programs'"
              @update="project.programs = $event"
              :items="project.programs"
            ></kv-suggestor-multiple>
          </vertical-field>
          <vertical-field>
            <label for="" class="label" slot="label"
              >Programme [description]
              <span
                v-if="project.program_description"
                :class="
                  project.program_description &&
                  project.program_description.length > 150
                    ? 'has-text-danger'
                    : ''
                "
                >({{ project.program_description.length }} / 150)</span
              ></label
            >
            <textarea
              name=""
              id=""
              cols="30"
              rows="3"
              class="textarea is-small "
              v-model="project.program_description"
            ></textarea>
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Programme Scalène</label>
            <textarea
              name=""
              id=""
              cols="30"
              rows="3"
              class="textarea is-small "
              v-model="project.program_scalene"
            ></textarea>
          </vertical-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KvSuggestorMultiple from "../../../components/Form/KvSuggestorMultiple";
import VerticalField from "../../../components/Form/VerticalField";
import VioletBar from "../VioletBar";
import HelpMessage from "../../../components/Form/HelpMessage";

export default {
  name: "ProjectEdit-Nature",
  components: { HelpMessage, KvSuggestorMultiple, VerticalField, VioletBar },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  }
};
</script>
